import {imgData, OptimizationAction, OptimizationState} from "./types";

const initialInputState: OptimizationState = {
    imgInProgress: {},
    imgURL: {}
};

export const optimization = (
    state: OptimizationState = initialInputState,
    action: OptimizationAction
): OptimizationState => {
    switch (action.type) {
        case "SETOPTIMIZATIONINPROGRESS":
            return { ...state, imgInProgress: {...state.imgInProgress, [action.payload]: true}};

        case "ADDOPTIMIZATIONIMGURL":
            imgData[action.payload.id] = action.payload.url;
            return { ...state, imgURL: {...state.imgURL, [action.payload.id]: true}};

        default:
            return state;
    }
};